import {
    CONFIRMED_GET_PROERTY_BANK_VERIFY_LISTS,
    CONFIRMED_GET_PROERTY_BANK_VERIFY_MESSAGES
} from '../actions/propertyBankVerification/PropertyBankVerificationTypes';
const initialState = {
    propertyBankVerifyLists: [],
    propertyBankVerifyMessages: [],
    test: [],
    loading: false
};

function PropertyBankVerificationReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'SET_BANK_VERIFICATION_LOADING':
            return {
                ...state,
                loading: actions.payload,
            };
        case CONFIRMED_GET_PROERTY_BANK_VERIFY_LISTS:
            return {
                ...state,
                propertyBankVerifyLists: actions.payload,
                loading: false,
            };
        case CONFIRMED_GET_PROERTY_BANK_VERIFY_MESSAGES:
            return {
                ...state,
                propertyBankVerifyMessages: actions.payload,
            };
        default:
            return state;
    }
}

export {PropertyBankVerificationReducer};